/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink, NbAuthService, NbAuthResult } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN } from '../constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { SearchCountryField, CountryISO,PhoneNumberFormat, } from 'ngx-intl-tel-input';
import { AdminOtpComponent } from '../admin-otp/admin-otp.component';
import { NbDialogService } from '@nebular/theme';
import { ApplicationApi } from '../../../@core/backend/common/api/application.api';
import { ConfirmationService } from 'primeng/api';
import { OtpComponent } from '../otp/otp.component';

@Component({
  selector: 'ngx-register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
  providers: [ConfirmationService,],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxRegisterComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  minmobileLength:number = 0;
  maxmobileLength:number = 10;
  mincountryCodeLength:number = 1;
  maxcountryCodeLength:number = 10;

  minfirstNameLength:number = 2;
  maxfirstNameLength:number = 20;
  textOnlyRegex = /^[A-Za-z]+$/;

  minFatherNameLength:number = 2;
  maxFatherNameLength:number = 20;

  minMotherNameLength:number = 2;
  maxMotherNameLength:number = 20;

  minlastNameLength:number = 2;
  maxlastNameLength:number = 20;
  // minLoginLength: number = this.getConfigValue(('forms.validation.fullName.minLength'));
  // maxLoginLength: number = this.getConfigValue(('forms.validation.fullName.maxLength'));
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  isFullNameRequired: boolean = this.getConfigValue('forms.validation.fullName.required');
  isFatherNameRequired: boolean = this.getConfigValue('forms.validation.fatherName.required');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  redirectDelay: number = this.getConfigValue('forms.register.redirectDelay');
  showMessages: any = this.getConfigValue('forms.register.showMessages');
  strategy: string = this.getConfigValue('forms.register.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  readonly: '';

  registerForm: FormGroup;
  isMobileRequired: number;
  isLastNameRequired: number;
  phoneForm:FormGroup;
  isMotherNameRequired: number;
  emailcheck: any;
  emailverify: boolean;
	// phoneForm = new FormGroup({
	// 	phone: new FormControl(undefined, [Validators.required])
	// });
  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    private fb: FormBuilder,
    protected router: Router,
    protected initUserService: InitUserService,
    private dialogService: NbDialogService,
    private api: ApplicationApi,
    private ConfirmationService: ConfirmationService,
    ) {
  
  }
  get firstName() { return this.registerForm.get('firstName');}
  get lastName() { return this.registerForm.get('lastName');}
  get fatherName() { return this.registerForm.get('fatherName');}
  get motherName() { return this.registerForm.get('motherName');}
  get email() { return this.registerForm.get('email'); }
  get dob() { return this.registerForm.get('dob'); }
  get gender (){return this.registerForm.get('gender');}
  get mobile() {return this.registerForm.get('mobile');}
  get countryCode() {return this.registerForm.get('countryCode');}

  get password() { return this.registerForm.get('password'); }
  get confirmPassword() { return this.registerForm.get('confirmPassword'); }
  get terms() { return this.registerForm.get('terms'); }
  get phone(){return this.registerForm.get('phone')}

  separateDialCode = false;
  SearchCountryField: SearchCountryField;
   CountryISO: CountryISO;
preferredCountries : CountryISO[]=[
  CountryISO.UnitedStates,
  CountryISO.UnitedKingdom,
  CountryISO.India
]
selectedCountryISO :CountryISO[]=[
  CountryISO.India
]



PhoneNumberFormat = PhoneNumberFormat;
  ngOnInit(): void {


    
    const mobileValidators =[
      Validators.minLength(this.minmobileLength),
      Validators.maxLength(this.maxmobileLength),

    ];
     this.isMobileRequired && mobileValidators.push(Validators.required);

    const firstNameValidators =[
      Validators.minLength(this.minfirstNameLength),
      Validators.maxLength(this.maxfirstNameLength),
      Validators.pattern(this.textOnlyRegex)

    ];
    this.isFullNameRequired && firstNameValidators.push(Validators.required);

    const fatherNameValidators =[
      Validators.minLength(this.minFatherNameLength),
      Validators.maxLength(this.maxFatherNameLength),
      Validators.pattern(this.textOnlyRegex)


    ];
    this.isFatherNameRequired && fatherNameValidators.push(Validators.required);

    const motherNameValidators =[
      Validators.minLength(this.minMotherNameLength),
      Validators.maxLength(this.maxMotherNameLength),
      Validators.pattern(this.textOnlyRegex)


    ];
    this.isMotherNameRequired && motherNameValidators.push(Validators.required);


    const lastNameValidators =[
      Validators.minLength(this.minlastNameLength),
      Validators.maxLength(this.maxlastNameLength),
      Validators.pattern(this.textOnlyRegex)


    ];
    this.isLastNameRequired && lastNameValidators.push(Validators.required)

    // const loginValidators = [
    //   Validators.minLength(this.minLoginLength),
    //   Validators.maxLength(this.maxLoginLength),
    // ];
    // this.isFullNameRequired && loginValidators.push(Validators.required);

    const emailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    this.isEmailRequired && emailValidators.push(Validators.required);


    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.registerForm = this.fb.group({
      firstName: this.fb.control('',[...firstNameValidators]), 
     lastName: this.fb.control('',[...lastNameValidators]),
      fatherName: this.fb.control('',[...fatherNameValidators]),
      motherName: this.fb.control('',[...motherNameValidators]),
      // fullName: this.fb.control('', [...loginValidators]),
      mobile: this.fb.control('',[...mobileValidators]),
      email: this.fb.control('', [...emailValidators]),
      countryCode: ['', [Validators.required]],
      dob: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      password: this.fb.control('', [...passwordValidators]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
      terms: this.fb.control(''),
      phone: ['', [Validators.required]],
      aadharNo: this.fb.control('',[Validators.required,Validators.maxLength(12),Validators.minLength(12),Validators.pattern(/^\d+$/)]),
      
      

    });
    
  } 

  register(): void {
    
    this.user = this.registerForm.value;
    
    this.errors = this.messages = [];
    this.submitted = true;
    this.user.user_type="student";
     
    // 

    this.service.register(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        //TODO : email authentication verification
       // this.initUser();
       const dataWithPayload = result.getToken() as unknown as { accessTokenPayload: { id: number } };
       const id = (dataWithPayload as any).accessTokenPayload.id;
       
       this.dialogService.open(OtpComponent, {
        context: {
            // email:this.userEmail,
            // password:this.userPassword,
            // userCountryCode: this.userCountryCode,
            // userContactNo :this.userContactNo,
            user_id : id
        },
      });
      } else {
        this.errors = result.getErrors(); 
      }
     const redirect = '/auth/login?verify=' + '1';
      alert("Registration Successful, Your login details have been emailed to you for future reference.");
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  phonefuc(event){




// this.fb.control.phone.setValue(this.options[0]);
this.registerForm.controls['countryCode'].setValue(event.value.dialCode)

this.registerForm.controls['mobile'].setValue(event.value.number)


  }

  // initUser() {
  //   this.initUserService.initCurrentUser()
  //     .pipe(
  //       takeUntil(this.destroy$),
  //     )
  //     .subscribe();
  // }

  onKeyPressNew(event:any){
    this.user = this.registerForm.value;
    this.emailcheck= this.user.email
    

    this.api.emailValues(this.emailcheck)
    .subscribe(
      (data: any) => {
      if(data['status'] == 400){
        
        
        this.ConfirmationService.confirm({
          message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
          icon: 'pi pi-exclamation-triangle',
          header: 'Confirmation',
          accept: () => {
            const redirect = '/auth/login';
            if (redirect) {
              setTimeout(() => {
                return this.router.navigateByUrl(redirect);
              }, this.redirectDelay);
            }
          },
          reject: () => {
          this.emailverify=true

          }
      });


      } else{
      }
      err => console.error(err)
    });


  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
